export const selectApiClient = (state) => state.apiClient.toJS();

export const apiClientHasRequest = (state, type) => state.apiClient.hasIn(['requests', type]);

export const apiClientCountRequests = (state, types) =>
  state.apiClient
    .get('requests')
    .reduce((result, value, key) => (types.indexOf(key) === -1 ? result : result + 1), 0);

export const selectErrorByType = (state, type) => state.apiClient.getIn(['errors', type]);

export const getBeginType = (type) => `${type}___BEGIN`;
export const getErrorType = (type) => `${type}___ERROR`;

export const selectActiveRequestsCount = (state) => state.apiClient.get('requests').size;
